import React from 'react'
import { Badge } from '@evertel/web/ui'
import { getDepartmentTrialStatus } from '@evertel/department'
import { APIDataDepartment } from '@evertel/types'

interface DepartmentStatusBadgeProps {
    department: APIDataDepartment
}

const DepartmentStatusBadge: React.FC<DepartmentStatusBadgeProps> = ({ department }) => {
    if (!department) return null

    const status = getDepartmentTrialStatus(department)

    const getStatusColor = (status: ReturnType<typeof getDepartmentTrialStatus>) => {
        switch (status) {
            case 'active':
                return 'success'
            case 'in_trial':
                return 'info'
            case 'trial_expired':
                return 'warning'
            case 'churned':
                return 'danger'
            default:
                return 'secondary'
        }
    }

    const getStatusText = (status: ReturnType<typeof getDepartmentTrialStatus>) => {
        switch (status) {
            case 'active':
                return 'Active'
            case 'in_trial':
                return 'In Trial'
            case 'trial_expired':
                return 'Trial Expired'
            case 'churned':
                return 'Churned'
            default:
                return 'Unknown'
        }
    }

    return (
        <Badge color={getStatusColor(status)} className="ms-2">
            {getStatusText(status)}
        </Badge>
    )
}

export { DepartmentStatusBadge }
